import * as React from 'react';
import {
    SelectInput,
    SimpleForm,
    useRecordContext,
} from 'react-admin';
import { workerTypeChoices } from '../jobs/utils'
import { workerStatusChoices, workerStatusChoicesUser, validateForm } from './utils';
import SectionTitle from '../commons/SectionTitle';

export const WorkerForm = () => (
    <SimpleForm sx={{ maxWidth: 500 }} validate={validateForm()}>
        <SectionTitle label="Worker" />
        <SelectInput source="type" choices={workerTypeChoices} 
            defaultValue={workerTypeChoices[0].id} 
        isRequired fullWidth/>
        <SelectInput source="status" choices={workerStatusChoicesUser} fullWidth/>
    </SimpleForm >
);

export const WorkerTitle = () => {
    const record = useRecordContext();
    if (record) {
        const workerType = workerTypeChoices.find(item => item.id == record.type).name;
        const workerStatus = workerStatusChoices.find(item => item.id == record.status).name;
        return <span>{`${workerStatus} "${workerType}" #${record.id}`}</span>;
    } else {
        return <span>{'Worker "Unknow"'}</span>;
    }
};
